// #region: Class definition *********************************************************************/
/**
 * Setup and handle events for the SignalR connection to the ApplicationHub.
 */
window.applicationhub = new class {

    // #region: Private Fields *******************************************************************/
    #connection;
    // #endregion ********************************************************************************/

    // #region: Constructor **********************************************************************/
    constructor() {
        /**
         * The signalR connection.
         */
        this.#connection = null;

        // Listen.
        eventBroadcaster.subscribe({message: broadcasts.APPLICATION_READY, subscriber: this});
    }
    // #endregion ********************************************************************************/

    // #region: Build ****************************************************************************/
    /**
     * Identifies class.
     * @returns {string}                        The string representation of this class.
     */
    toString() {
        return "[applicationhub]";
    }

    static toString() {
        return "[applicationhub]";
    }

    /** 
     * Identifies the version.
     * @returns {string}                        The version number of this class.
     */
    static version() {
        return "1.0.0";
    }
    // #endregion ********************************************************************************/

    // #region: Events ***************************************************************************/
    /**
     * Handle EventBroadcaster transmissions.
     * @param {String} message                  The broadcast message, @see {broadcasts}.
     * @returns {Void}
     */
    handleBroadcast({message}) {
        switch (message) {

            case broadcasts.APPLICATION_READY:
                this.#setupSignalR();
                break;

            default:
                break;
        
        }
    }
    // #endregion ********************************************************************************/

    // #region: Private Methods ******************************************************************/
    /**
     * Initialize & setup SignalR.
     */
    async #setupSignalR() {
        // Create the signalR connection.
        this.#connection = await messages.setupSignalR(`${ baseUrl }/ApplicationHub`);

        // Add listeners.
        this.#connection.on("MessageAsync", (message) => {
            messages.parseMessage(message);
        });
    }
    // #endregion ********************************************************************************/

}();
// #endregion ************************************************************************************/
